import { render } from "./CompPaymentProof.vue?vue&type=template&id=310b1c1a&scoped=true"
import script from "./CompPaymentProof.vue?vue&type=script&lang=js"
export * from "./CompPaymentProof.vue?vue&type=script&lang=js"

import "./CompPaymentProof.vue?vue&type=style&index=0&id=310b1c1a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310b1c1a"]])

export default __exports__